<template>
<v-responsive width="100%">
    <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="8" class="py-0">
            <v-row align="center">
                <v-spacer></v-spacer>
                <v-col cols="12" sm="auto" class="caption pb-0 pb-sm-3">회원이름</v-col>
                <v-col class="px-sm-0 py-0">
                    <v-text-field v-model="filter.searchValue" dense hide-details></v-text-field>
                </v-col>
                <v-col cols="auto" class="py-0">
                    <v-btn color="secondary" small @click="search">검색</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-data-table v-model="$data.targets" :items="users" item-key="_id" :headers="headers" show-select hide-default-footer disable-sort disable-pagination @input="$emit('input', $data.targets)">
    </v-data-table>

    <v-pagination v-model="page" :length="pageCount" :total-visible="10" color="secondary" class="mt-2" @input="search"></v-pagination>
</v-responsive>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            targets: this.$props.value || [],

            filter: {
                searchKey: "name",
                searchValue: null
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            users: this.$props.value || [],
            headers: [{
                    text: "이름",
                    align: "center",
                    value: "name"
                },
                {
                    text: "연락처",
                    align: "center",
                    value: "phone"
                },
                {
                    text: "이메일",
                    align: "center",
                    value: "email"
                },
            ]
        };
    },
    methods: {
        async search() {
            try {
                var {
                    summary,
                    users
                } = await api.console.users.getUsers({
                    params: this.filter
                });

                this.pageCount = Math.ceil(summary.totalCount / this.limit);
                this.users = users;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        }
    }
}
</script>
